import EqEventAlternative from "../../../../eqComponents/publicEvents/eqEventAlternative/EqEventAlternative";
import { EqDisciplineType, EqCurrency, EqEventRepeatType, EqTrainingLevels, EqEventHorseAvailabilityStatus, EqJoinPermissions, CourseOrderType, EqGroupUserType, EqEventAccessType, EqDisciplinesEnum, EqSlotStatusEnum, EqEventUserType, EqEventAttendeeStatus } from "../../enums";
import { CourseLessonOrderEnt, CourseLessonOrderUI, EqEntityEventUserGroup } from "../../general/IStudentUnpaidOrders";
import { ISelectOption } from "../../Interfaces";
import { EqLocationInfoDto, EqEventOrganizerInfoDto, EqEntityProductInfoDto } from "../GetSchoolTrainingInfoDto";
import { EqEntityEvent, IEqUiProfile } from "../IEqEventDto";
import { IEventUserGroupDto } from "../IEventUserGroupDto";
import { EqUiLocation, ILocationDto } from "../ILocationDto";
import {  EqImageInfoDto, EqUiImage } from "../Images/IImage";
import { EqUiGroup } from "../IUserGroupDto";
import { EqEntityUser, EqUiUser } from "../IUserInfoDto";
import { EqUiProfile, IUserProfileDto } from "../IUserProfileDto";
import { GetSchoolStudentsDto } from "../schoolTraining/school";


export interface CreateCourseUI {
    imageId?: string | null; // Guid
    image?: EqImageInfoDto  | null;
    title: string;
    description: string;
    currency?: EqCurrency | null;
    joinPermission?: EqJoinPermissions | null;
    startDate: number;
    endDate: number;
    coursePrice: number;
    vat: number;
    repeatType: EqEventRepeatType | null;
    weekDayIds: string[] | undefined; // Make it optional

    capacity: number;
  
    // Lesson Details
    lessons: number;
    lessonStartTime: string;
    lessonDurationMinutes: number;
    lessonPrice: number;
  
    schoolId: string; // Guid
    courseTrainerId: string; // Guid
    status: CourseStatus;
  
    selectedStudents: SelectedStudentDTO[];
  }
  
  
  export interface SelectedStudentDTO {
    studentKey: string; // Email or unique identifier
    horseId?: string | null; // Guid
  }
  


  export interface CourseDetailsDto {
    id: string;
    key: number; // UI identification - prefix
    imageId?: string | null;
    image?: EqImageInfoDto | null;
    title: string;
    description: string;
    currency?: EqCurrency | null;
    joinPermission?: EqJoinPermissions | null;
    coursePrice: number;
    vat: number;
    startDate: number; // Date in milliseconds
    endDate: number; // Date in milliseconds
    repeatType: EqEventRepeatType;
    weekDayIds: string[];
    capacity: number;
    lessons: number;
    lessonStartTime: string;
    lessonDurationMinutes: number;
    lessonPrice: number;
    schoolId: string;
    courseTrainerId: string;
    status: CourseStatus;
    selectedStudents: SelectedStudentDTO[];
  }



export enum CourseStatus {
    Drafted,
    Active,
    Paused,
    Completed,
    Deleted,
    Requested
}
export enum EqRefundType {
    NoRefund,
    Refund,
    Credit,
}
export enum EqUserProfessionType {
    None = 0,
    Administrator,
    Trainer,
    Student,
    Veterinarian,
    Farrier,
    Therapist,
    EventHolder,
    RidingSchool,
    Stable,
    Parent
}

export enum EqUserType {
    Student = 1,
    Group = 2
}
export enum EqPaymentStatus {
    Paid = 1,
    Unpaid,
    UnpaidButAttending,
    PaidButCancelled,
    Refunded
}

export enum EqPaymentSourceType {
    Card = 1,
    Cash = 2
}

export interface EqUiPayment {
    key: number;
    paymentDate: number;
    status: EqPaymentStatus;
    paymentReminder: boolean;
    note: string;
    paymentSourceType: EqPaymentSourceType;
    user: ICourseStudent;
    userEmails: string[] | null;
    createdDate: number;
}
//export interface 
export interface ISchoolStudents {
    key: string;
    userType: EqUserType;
    user: IEqUserInfoDto;
    school: IEqUserInfoDto;
}



export enum EqOrderStatus {
    Pending,
    Accepted,
    Rejected,
    Paid,
    Requested,
    Waiting,
    OwnerCancelled,
    AttendeeCancelled
}

export interface IEqTrainingCourseBoard {
    updateCount?: (count: number) => void;
    activeCourse?: CourseUI;
}

export enum EqGroupType {
    House = 1,
    Stable = 2,
    People = 3,
    Event = 4,
    Horse = 5
}
export interface IEqGroupDto {
    id: string;
    Key: number;
    Name: string;
    type: EqGroupType;
    Message: string;
    Color: string;
}

export interface ICourseStudent {
    email: string;
    key: number;
    id: string;
    firstName: string;
    lastName: string;
}
export interface ICourseUser {
    id: string;
    key: number;
    email: string;
    firstName: string;
    lastName: string;
}


export interface ICourseLessonOrderUI {
    id?: string;
    key: number;
    orderStatus: EqOrderStatus;
    createDate: number;
    updateDate: number;
    studentId: string;
    student: IEqUserInfoDto;
    payment?: EqUiPayment;
    paymentMethod: EqPaymentSourceType;
    course?: CourseUI;
    orderType: CourseOrderType;
    horseId?: string;
    horse?: EqEntityHorse;
    courseLessonId?: string;
    courseLesson?: CourseLessonEnt;
    courseId?: string;
    customPrice?: number;
    creditId?: string;
}
export interface ICourseLessonUI {
    id: string;
    key: number;
    disciplineType: EqDisciplineType;
    currency: EqCurrency | null;
    startDate: number;
    endDate: number;
    startTime: number;
    endTime: number | null;
    durationMinutes: number;
    capacity: number;
    price: number;
    isRepeat: boolean;
    repeatType: EqEventRepeatType;
    trainingLevel: EqTrainingLevels;
    horseAvailabilityStatus: EqEventHorseAvailabilityStatus;
    createdDate: number;
    locationId: string;
    location: ILocationDto;
    isDeleted: boolean;
    courseLessonOrders: Array<ICourseLessonOrderUI>;
    course: CourseUI;
    
}

export interface CourseLessonUI {
    id: string;
    key: number;
    currency?: EqCurrency | null;
    startTime: number;
    endTime?: number | null;
    durationMinutes: number;
    capacity: number;
    price: number;
    vat: number;
    createdDate: number;
    isRepeat: boolean;
    courseLessonOrders: CourseLessonOrderUI[];
    courseId: string;
    course: CourseUI;
    isDeleted: boolean;
    trainerId?: string | null;
    trainer?: EqEntityUser | null;
  }
  


export interface CourseUI {
    id:string;
    key: number;
    title: string;
    description: string;
    currency: EqCurrency | null;
    joinPermission: EqJoinPermissions | null;
    startDate: number;
    endDate: number;
    coursePrice: number;
    vat: number;
    repeatType: EqEventRepeatType;
    weekDayIds: Array<string>;
    lessonStartTime: string;
    lessonDurationMinutes: number;
    capacity: number;
    lessonPrice: number;
    lessons: number;
    imageId: string | null;
    image: EqImageInfoDto;
    createdDate: number;
    schoolId: string;
    school: ICourseUser;
    courseTrainerId: string;
    courseTrainer: ICourseUser;
    status: CourseStatus;

    courseLessonOrders: Array<ICourseLessonOrderUI>;
    courseLessons: Array<ICourseLessonUI>;

    createdById: string;
    createdBy: ICourseUser;
}



export enum HorseTypeEnum {
    Stallion = 1,
    Gelding,
    Mare
}

export interface IEqEntityHorseInfoDto {
    id: string
    key: number;
    name: string;
    About: string;
    Type: HorseTypeEnum;
    ImageURL: string;
}

interface Horse {
    key: string;
    value: string;
    label: string;
}

export interface IHorseData {
    key: string;
    horseList: Horse[];
}

export interface IEqUserInfoDto {
    id: string;
    key: number;
    firstName: string;
    lastName: string;
    CompanyName: string;
    SchoolName: string;
    email: string;
    UserName: string;
    phoneNumber: string;
    ProfessionType: EqUserProfessionType;
    UserImage: EqImageInfoDto;
    AllowLatePayments: boolean;
    //CancellationDeadline: long;
    RefundType: EqRefundType;
    AllowProductTrainingCancel: boolean;
    ProductRefundType: EqRefundType;
    horses: IEqEntityHorseInfoDto[];
    PaymentStatus: number;
    Groups: IEqGroupDto;
    data: any;
}

export interface ITrainerOption {
    key: number;
    value: string;
    label: string;
    icon: {
        type: {
            defaultProps: {
                shape: string;
                size: string;
            };
        };
        key: null | string;
        ref: null | string;
        props: {
            size: number;
            src: string;
            shape: string;
        };
        _owner: null | string;
        _store: Record<string, unknown>;
    };
}


export interface TrainingCourseCreateProp {
    imagesData: EqImageInfoDto[];
    onClose: () => void;
    onImageUploadSuccess: (newImage: any) => void;
    onImageDeleteSuccess: (imageId: any) => void;
    creatorUser?: IEqUiProfile;
    trainersOptions: ITrainerOption[];
    schoolStudents: any;
    studentHorsesList?: GetSchoolStudentsDto[];

    onCreateCourse?: (data: any,isPublishDraft:boolean,draftCourseId?: string) => void;
    onEditCourseDetails?: (data: any) => void;
    onEditCourseLesson?: (data: any) => void;
    editCourse?: CourseUI; 
    onRemoveLessonOrder?: (lessonId:string,order: any, refund: boolean, refundAmount?: number) => void;
    
    onRemoveCourseOrder?: (order: any, refund: boolean, refundAmount?: number) => void;
    isStudent?: boolean;
    onAcceptCourseOrderRequest: (requestId: string) => void;
    onRejectCourseOrderRequest: (requestId: string) => void;
    onAcceptCourseLessonOrderRequest: (requestId: string) => void;
    onRejectCourseLessonOrderRequest: (requestId: string) => void;
    onDeleteCourseInvite: (inviteId: string) => void;
    onBuy?: () => void;
    onPayNow?: (orderId:string) => void;
    onPayNowLessonOrder?: (orderId:string) => void;

    onCourseLessonJoinRequest?: (lessonId:string) => void;

}

export interface TrainingCourseViewProp {    
    course?: CourseUI;     
    isStudent?: boolean;
    statusChanged?: (param: CourseStatus) => void;
    onBuy?: () => void;
    onPayNow?: (orderId:string) => void;
}



// export interface ISelectOption {
//     isDisabled?: string;
//     key?: string;
//     value?: string;
//     title?: string;
//     calssName?: string;
// }

export interface ICourseStudentList {
    student: ISelectOption;
    horse: ISelectOption;
}
export interface ICourseCreateForm {
    imageData: EqImageInfoDto;
    trainer: ISelectOption;
    title: string;
    description: string;
    startDate: any;
    endDate: any;
    from: any;
    lesonWeeks: number;
    totalPrice: number;
    individualPrice: number;
    studentList: Array<ICourseStudentList>
};

//export interface I
export interface CourseCreateForm {
    id?:string;
    image: EqImageInfoDto| null;
    imageId: string | null;
    title: string;
    description: string;
    startDate: any;
    endDate: any;
    currency: EqCurrency | null;
    joinPermission: EqJoinPermissions | null;
    coursePrice: number;
    vat: number;
    repeatType: EqEventRepeatType| null;
    weekDayIds?: Array<string>,
    lessonStartTime:string;
    lessonDurationMinutes: number;
    capacity: number;
    lessonPrice: number;
    lessons: number;
    schoolId?: string;
    courseTrainerId: string;
    // selectedStudents?: Array<ICourseStudent>
    selectedStudents?: Array<SelectedStudentDTO>
   
    status: CourseStatus;

}

export interface ISelectedStudentDTO {
    StudentKey: string;
    HorseId?: string;
}


export interface EqEntityCredit {
    id: string; // Corresponds to Guid in C#
    userId: string; // Corresponds to Guid in C#
    eventId: string; // Corresponds to Guid in C#
    dateIssued: number; // Corresponds to long in C#
    isUsed: boolean; // Corresponds to bool in C#
    fromUserId: string; // Corresponds to Guid in C#
    creditType: CreditType; // Assumes a matching TypeScript enum or type for CreditType
}

export enum CreditType {
  
    Course, // for full course
    TrainingLesson // for only Lesson

}


interface EqEntityHorse {
    id: string;
    key: number;
    name: string;
    about: string;
    dateOfBirth: number;
    type?: HorseTypeEnum; // Assuming HorseTypeEnum is defined elsewhere
    imageUrl?: string;
    userId: string;
    user: IEqUserInfoDto;
    horseTasks: EqEntityHorseTask[]; // Assuming EqEntityHorseTask is defined elsewhere
    horseTrainings: EqEntityHorseTraining[]; // Assuming EqEntityHorseTraining is defined elsewhere
    userGroups?: EqEntityUserGroup[]; // Assuming EqEntityUserGroup is defined elsewhere
    assignings: EqEntityHorseAssignings[]; // Assuming EqEntityHorseAssignings is defined elsewhere
}

interface CourseLessonEnt {
    id: string;
    key: number;
    currency?: EqCurrency; // Assuming EqCurrency is defined elsewhere
    startTime: number;
    endTime?: number;
    durationMinutes: number;
    capacity: number;
    price: number;
    vat: number;
    createdDate: number;
    courseId: string;
    course: CourseEnt; // Assuming CourseEnt is defined elsewhere
    courseLessonOrders: CourseLessonOrderEnt[];
    isDeleted: boolean;
    trainerId?: string;
    trainer?: IEqUserInfoDto;
}

//export interface CourseLessonOrderEnt {
//    id: string;
//    key: number;
//    orderStatus: EqOrderStatus;
//    createDate: number;
//    updateDate: number;
//    studentId: string;
//    student: IEqUserInfoDto;
//    horseId?: string;
//    horse?: EqEntityHorse;
//    courseLessonId?: string;
//    courseLesson?: CourseLessonEnt;
//    courseId?: string;
//    course?: CourseEnt; 
//    orderType: CourseOrderType; 
//    payment?: any;
//    customPrice?: number;
//    creditId?: string;
//}

export interface CourseEnt {
    id: string;
    key: number;
    imageId?: string;
    image?: any;
    title: string;
    description: string;
    currency?: EqCurrency;
    joinPermission?: any;
    startDate: number;
    endDate: number;
    coursePrice: number;
    vat: number;
    repeatType: EqEventRepeatType;
    weekDayIds: string[];
    capacity: number;
    lessons: number;
    lessonStartTime: string;
    lessonDurationMinutes: number;
    lessonPrice: number;
    createdDate: number;
    schoolId: string;
    school: IEqUserInfoDto;
    createdById: string;
    createdBy: IEqUserInfoDto;
    courseTrainerId: string;
    courseTrainer: IEqUserInfoDto;
    courseLessonOrders: CourseLessonOrderEnt[];
    courseLessons: CourseLessonEnt[];
    status: CourseStatus;
}
enum HorseTaskTypeEnum {
    Deworming,
    Shoes,
    Vaccination,
    Vet,
    Other
}

enum HorseTaskStatusEnum {
    Planned,
    Completed
}

enum HorseTrainingTypeEnum {
    Dressage = 1,
    Jumping = 2,
    Lunging = 3,
    Hacking = 4,
    PoleWork = 5,
    Other = 6
}

enum HorseAssigningStatusEnum {
    Active,
    Finished
}
interface EqEntityHorseTask {
    id: string;
    key: number;
    date: number;
    time: number;
    description: string;
    notificationTime: number;
    horse: EqEntityHorse;
    horseId: string;
    taskType: HorseTaskTypeEnum;
    status?: HorseTaskStatusEnum;
}

interface EqEntityHorseTraining {
    id: string;
    key: number;
    date: number;
    time: number;
    description: string;
    notificationTime: number;
    durationInMinutes: number;
    horse: EqEntityHorse;
    horseId: string;
    trainingType: HorseTrainingTypeEnum;
    status?: HorseTaskStatusEnum;
}

export interface EqEntityUserGroup {
    id: string;
    key: number;
    userId: string;
    user: IEqUserInfoDto;
    groupId: string;
    group: any;
    referenceGroupId?: string;
    userType: EqGroupUserType;
    horseId?: string;
    horse?: EqEntityHorse;
}

interface EqEntityHorseAssignings {
    id: string;
    key: number;
    type: any;
    userId: string;
    user: IEqUserInfoDto;
    startDate: number;
    endDate?: number;
    status: HorseAssigningStatusEnum;
}
export interface ICombinedEvent {
    id: string;
    key: number;
    title: string;
    description: string;
    startDate: number;
    endDate: number;
    currency?: EqCurrency;
    locationId: string;
    location: EqLocationInfoDto | any;
    phoneNumber?: string;
    email?: string;
    isDraft?: boolean;
    isDeleted?: boolean;
    createdDate?: number;
    registrationDeadline?: number;
    paymentDeadline?: number;
    eventTermsFile?: string;
    useHouseTerms?: boolean;
    houseTerms?: string;
    userId?: string;
    user?: IEqUserInfoDto;
    alternatives?: typeof EqEventAlternative[]; // Fix: Use `typeof` if `EqEventAlternative` is a value
    eventClasses?: any;
    eventQuestions?: any;
    eventImage?: string;
    eqImage?: any;
    display?: boolean;
    isRepeat: boolean; // Fix: Make `isRepeat` non-optional
    repeatType?: EqEventRepeatType;
    startTime?: number;
    endTime?: number;
    duration?: number;
    disciplineType?:  EqDisciplineType;
    disciplineTypes?: EqEventAccessType[];
    locationKey?: number;
    maxAvailableSpace?: number;
    isPaid?: boolean;
    price?: number;
    paymentMethod?: EqPaymentSourceType;
    isLatePayment?: boolean;
    message?: string;
    trainingLevel?: EqTrainingLevels;
    accessType: EqEventAccessType; // Fix: Make `accessType` non-optional
    horseAvailabilityStatus?: EqEventHorseAvailabilityStatus;
    attendees?: IEventUserGroupDto[];
    payments?: any;
    eventLocation?: ILocationDto;
    organizers?: IUserProfileDto[] | EqEventOrganizerInfoDto[];
    referenceKey?: string;
    trainerKey?: number;
    productId?: string;
    product?: EqEntityProductInfoDto;
    lessonNumber?: number;
    selectedGroups?: number[];
    trainingTimes?: any;
}

enum EqPaymentAccountStatus {
    Pending = 1,
    NotCompleted,
    Complete
}

enum EqPaymentAccountType {
    Stripe = 1,
    Vipps = 2
}

 export interface EqUiPaymentAccount {
    type: EqPaymentAccountType;
    accountNumber: string;
    accountUser: EqEntityUser;
    userId: string; 
    balance: number;
    country: string;
    currency: string;
    status: EqPaymentAccountStatus;
 }

export interface EqUiEvent {
    id: string; // Guid maps to string in TypeScript
    key: number;
    title: string;
    disciplineType: EqDisciplinesEnum;
    startDate?: number | null; // long? maps to number | null
    endDate: number; // long maps to number
    productId?: string | null; // Guid? maps to string | null
    product?: EqEntityProductUiInfo | null;
    lessonNumber?: number | null;
    startTime?: number | null; // long? maps to number | null
    endTime?: number | null; // long? maps to number | null
    duration?: number | null;
    maxAvailableSpace?: number | null;
    isLatePayment: boolean;
    paymentDeadline?: number | null; // long? maps to number | null
    currency?: EqCurrency | null;
    isPaid: boolean;
    price?: number | null; // long? maps to number | null
    message: string;
    paymentMethod: EqPaymentSourceType;
    locationKey: number;
    location: string;
    isRepeat: boolean;
    repeatType?: EqEventRepeatType | null;
    trainingLevel?: EqTrainingLevels | null;
    accessType: EqEventAccessType;
    horseAvailabilityStatus: EqEventHorseAvailabilityStatus;
    weekDayIds: string[];
    selectedGroups: number[];
    eventLocation: EqUiLocation;
    createdDate?: number | null;
    organizers?: EqUiProfile[];
    // organizers?: IUserProfileDto[] | EqEventOrganizerInfoDto[];
    // attendees: IEventUserGroupDto[];
    attendees: EqUiEventUserGroup[];
    payments: EqUiPayment[];
    eqImage?: EqUiImage | null;
    trainingTimes?: TrainingTimes[] | null;
    attendeesHorse?: EqUiAttendeeHorse[] | null;
    multipleStartDates?: number[] | null;
} 

export interface EqUiEventUserGroup {
    eventKey: number;
    event: EqUiEvent;
    key: string;
    user: EqUiUser;
    groupKey?: number | null;
    group?: EqUiGroup | null;
    slotStartTime: number;
    slotStatus: EqSlotStatusEnum;
    slotCancelledDate?: number | null;
    eventUserType: EqEventUserType;
    userStatus?: EqEventAttendeeStatus | null;
    horseId?: string | null; // Guid as string
    horse?: EqEntityHorse | null;
    creditId?: string | null; // Guid as string
  }


  export interface TrainingTimes {
    startTime: number;
    endTime?: number | null;
    duration: number;
    maxAvailableSpace: number;
    attendees: EqUiEventUserGroup[];
    attendeesHorse: EqUiAttendeeHorse[];
    trainingLevel?: EqTrainingLevels | null;
    price?: number | null;
  }
  

interface EqUiAttendeeHorse {
    key: string;
    horseId: string; // Guid maps to string
}

interface EqEntityProductUiInfo {
    title: string;
    limit?: number | null; // long? maps to number | null
    lessons?: number | null; // long? maps to number | null
    individualPrice?: number | null; // long? maps to number | null
    price: number; // long maps to number
}

export interface EqEntityPayment {
    id: string; // Guid
    key: number;
    stripePaymentIntentId?: string | null;
  
    eqEntityEventUserGroupId?: string | null;
    eqEntityEventUserGroup?: EqEntityEventUserGroup | null;
  
    paymentDate: number; // Unix timestamp
    status: EqPaymentStatus;
    paymentReminder: boolean;
    note?: string | null;
    paymentSourceType: EqPaymentSourceType;
    userId: string;
    user: EqEntityUser;
    eventId: string;
    event: EqEntityEvent;
    refundAmount: number;
  
    courseLessonOrderId?: string | null;
    courseLessonOrder?: CourseLessonOrderEnt | null;
  }
  

